export default "__VITE_ASSET__3c522ac4__"